<template>
  <modal-brandme :show_modal="open_modal_login" :size="'lg'">
    <template #title>
        {{ $t('creator.previewContent')}}
    </template>
    <template #body>
      <b-card
        no-body
        class="card card-image-content card-type-content p-1"
      >
        <div class="mb-1 d-flex align-items-center">
          <div class="position-relative mr-1">
            <b-avatar
              size="3.5rem"
              variant="light-secondary"
              :src="verifyAsset(info_creator.sender.avatar)"
            ></b-avatar>
            <b-avatar
              class="icon-network p-0 position-absolute"
              variant="light"
              size="20px"
            >
              <b-img
                :src="`${getIconWhite('instagram')}`"
                :class="getIconColor('instagram', false)"
                fluid
              ></b-img>
            </b-avatar>
          </div>

          <div class="d-flex flex-column">
            <span>
                {{ info_creator.sender.first_name }} {{ info_creator.sender.last_name }}
              <image-verified
            /></span>
            <small class="text-muted">
              {{ $t("campaigns.post") }} · Ahora
            </small>
          </div>
        </div>

        <b-link target="_blank">
            <video
                class="w-100"
                :src="asset_url"
                :autoplay="false"
                :loop="true"
                controls
                controlsList="nodownload"
                ref="video"
                v-if="type_content === 'video'"
            ></video>
          <b-img-lazy
            v-if="type_content === 'image'"
            class="card-image-content"
            :src="asset_url || backgroundDefault"
            @error="errorLoad(info_creator.uuid)"
          />
        </b-link>
        <div class="card-content-all">
          <div class="container-interactions">
            <div
              class="d-flex justify-content-between align-items-center w-100 avenir-light mb-05 flex-wrap mt-1"
            >
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-05">
                  <b-icon class="mr-05" icon="play-circle" />
                  <span>{{ getFormat(getRandomNumber()) }}</span>
                </div>
                <div class="d-flex align-items-center mr-05">
                  <b-icon class="mr-05" icon="heart-fill" />
                  <span>{{ getFormat(getRandomNumber()) }}</span>
                </div>
                <div class="d-flex align-items-center mr-05">
                  <b-icon class="mr-05" icon="chat" />
                  <span>{{ getFormat(getRandomNumber()) }}</span>
                </div>
              </div>
            </div>
            <div class="metric-row">
              <span class="avenir-light">{{ $t("campaigns.shareTime") }}</span>
              <span class="metric-line"></span>
              <span>{{ getFormat(getRandomNumber()) }}</span>
            </div>
            <div class="text-start mb-05 avenir-light text-overflow mt-1 w-100">
              {{info_creator.text_publish}}
            </div>

          </div>
        </div>
      </b-card>
      <div v-if="download" class="d-flex justify-content-center">
        <b-button class="blue-button mt-2" variant="blue-button" @click="downloadAsset">
          {{  $t('campaigns.download_content') }}
        </b-button>
    </div>
    </template>
  </modal-brandme>
</template>
  
<script>
import { BCard, BAvatar, BImg, BLink, BIcon, BImgLazy, BButton } from "bootstrap-vue";
import modalBrandme from "@/views/components/modal/ModalBrandme.vue";
import { getFormat } from "@/libs/utils/formats";
import { getIconWhite, getIconColor } from "@/libs/utils/icons";
import { verifyAsset } from "@/libs/utils/urls";
import chat_service from '@/services/chat';

export default {
  name: "ModalContentPreview",
  components: {
    BCard,
    BAvatar,
    BImg,
    BLink,
    BIcon,
    BImgLazy,
    modalBrandme,
    BButton,
    ImageVerified: () => import("@/views/components/image/ImageVerified.vue"),
  },
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    asset_url: {
      type: String,
    },
    type_content: {
      type: String,
      default: "",
    },
    download: {
      type: Boolean,
      default: false,
    },
    info_creator: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      getIconWhite,
      getIconColor,
      verifyAsset,
      getFormat,
      open_modal_login: this.open_modal,
    };
  },
  methods: {
    errorLoad(uuid) {
      chat_service.getAssetContentUrl(uuid).then((response) => {
        const img_new = response.asset_url;
        this.asset_url = img_new;
      });
    }, 
    getRandomNumber() {
      return Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000
    },
    downloadAsset() {
      if (this.type_content === "image") {
        window.open(this.asset_url, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = this.asset_url;

        const filename = this.asset_url.split("/").pop() || "archivo";

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
};
</script>
  
<style scoped>
.metric-row {
  display: flex;
  align-items: center;
  width: 100%;
}
.metric-line {
  flex-grow: 1;
  border-bottom: 1px dashed #ccc;
  margin: 0 8px;
}
.container-interactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.card-content-all {
  width: 100%;
}
.icon-network {
  position: relative;
  top: 30px;
  z-index: 9;
  background: white;
  border-radius: 50%;
  bottom: 0;
  right: 0;
}
.hover-card:hover {
  transform: scale(1.05);
  transition: all 500ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-radius: 1%;
}
.card-type-content {
  display: flex;
  height: 90%;
}
.text-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>